import { mdiAlertCircle } from '@mdi/js';
import React from 'react';
import * as S from './compose-error.styles';

export interface IComposeErrorProps {
    children?: React.ReactElement | string;
}

export const ComposeError: React.FunctionComponent<IComposeErrorProps> = (
    props: IComposeErrorProps,
): React.ReactElement => (
    <S.Error>
        <S.ErrorIcon path={mdiAlertCircle} size={0.75} />
        {props.children}
    </S.Error>
);
